
const host = process.env.REACT_APP_BACKEND_URL;

const contextsKeys = ['F', 'M', 'C', 'I'];

const contextsNames = ['Fronterizo', 'Metropolitano', 'Costero', 'Indígena y/o Afromexicano']

const contextsColors = [ '1c5c50', 'cade6b', '79d0d0', 'c4ab73' ];

export {
    host,
    contextsKeys,
    contextsNames,
    contextsColors
}
